import {Component, OnInit, ViewChild} from '@angular/core';
import { PoliticaDePrivacidadeModalComponent } from 'src/app/core/politica-de-privacidade/politica-de-privacidade-modal/politica-de-privacidade-modal.component';

import { PoliticaDePrivacidadeService } from 'src/app/core/politica-de-privacidade/politica-de-privacidade.service';
import { Tenant } from 'src/app/seguranca/multi-tenancy/tenant/model/tenant.model';
import { TenantService } from 'src/app/seguranca/multi-tenancy/tenant/tenant.service';
import { Usuario } from 'src/app/seguranca/usuario/usuario/usuario.model';
import { UsuarioService } from 'src/app/seguranca/usuario/usuario/usuario.service';
import { environment } from 'src/environments/environment';
import { AmbienteService } from '../multi-tenancy/ambiente.service';


@Component({
    selector: 'app-footer',
    styleUrls: ['./app.footer.component.css'],
    templateUrl: './app.footer.component.html'
})
export class AppFooterComponent implements OnInit {

  @ViewChild('appPoliticaDePrivacidadeModal') appPoliticaDePrivacidadeModal: PoliticaDePrivacidadeModalComponent;
  
  public tenant: Tenant = null;

  public nomeOrganizacao = null;
  public nomeVersao = null;
  public ambiente = null;
  public arquivoLogoPequenaColorida = '';

  public isGEEO = false;

  constructor(
    private ambienteService: AmbienteService,
    private usuarioService: UsuarioService,
    private politicaDePrivacidadeService: PoliticaDePrivacidadeService,
    private tenantService: TenantService
  ) {
    this.nomeVersao = environment.nomeVersao;
    this.ambiente = this.ambienteService.getAmbiente();
    this.arquivoLogoPequenaColorida = this.ambiente.getArquivoLogoPequenaColorida();
   }

   exibirPolitica(): void {
    this.appPoliticaDePrivacidadeModal.exibir();
   }

   ngOnInit(): void {
    this.isGEEO = this.ambienteService.isGEEO();

    setTimeout(() => this.carregarNomeDoTenant(), 1000);
   }

   carregarNomeDoTenant(): void {
    this.tenantService
        .buscarTenantDoUsuarioLogado()
        .subscribe((tenant: Tenant) => this.tenant = tenant);
   }
}
